import { GetTokenSilentlyOptions, LogoutOptions } from '@auth0/auth0-react';
import { AssessmentState } from '../custom-hooks/useLrnSession';
import { PostHog } from 'posthog-js';
import type { LearnosityRequest } from '../models/LearnosityRequest';
import { isLearnosityRequest } from './LearnosityFetchError';
import { fetchLearnosityStartupData, type LearnosityFetchOptions } from './fetchLearnosityStartupData';

export interface LearnosityInitializationParams {
  state: AssessmentState;
  activityId: string;
  userId: string;
  sessionId: string;
  title: string;
  renderingType: 'assess' | 'inline';
  regions: object;
  showDistractorRationale?: boolean;
  showCorrectAnswers?: boolean;
  autoSaveAnswers?: boolean;
  responsiveRegions: boolean;
  showIntro?: boolean;
  scrollToTest?: boolean;
  scrollToTop?: boolean;
  skipSubmitConfirmation?: boolean;
  warningOnChange?: boolean;
}

export const getLearnosityInitObject = async (
  params: LearnosityInitializationParams,
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>,
  logout: (options?: LogoutOptions) => Promise<void>,
  posthog: PostHog,
  options: LearnosityFetchOptions = {},
): Promise<LearnosityRequest> => {
  return fetchLearnosityStartupData(
    {
      operation: 'init_object',
      path: '/v1/learnosity/init-object',
      method: 'POST',
      body: params,
      fields: {
        activityReference: params.activityId,
        activityTitle: params.title,
        assessmentState: params.state,
        renderingType: params.renderingType,
        learnerId: params.userId,
        sessionId: params.sessionId,
      },
      validate: isLearnosityRequest,
    },
    getAccessTokenSilently,
    logout,
    posthog,
    options,
  );
};
